/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'

const HeaderUserMenu: FC = () => {
  const {logout} = useAuth()
  const {t} = useTranslation()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-5'>
        <Link to='user/edit' className='menu-link px-5'>
          <i className='ki-duotone ki-user fs-2 me-3' />
          {t('MENU.PROFILE')}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to='/producer/general' className='menu-link px-5'>
          <i className='ki-duotone ki-information-5 fs-2 me-3' />
          {t('MENU.PRODUCER')}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <Link to='/userToken/list' className='menu-link px-5'>
          <i className='ki-duotone ki-key fs-2 me-3' />
          {t('MENU.TOKENS')}
        </Link>
      </div>

      <Languages />

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5 Link-Logout'>
          <i className='ki-duotone ki-exit-right fs-2 me-3' />
          {t('MENU.LOGOUT')}
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
